import React from "react";
import ProfileContainer from "../components/ProfileContainer";
import { useTalent } from "../../../providers/TalentProvider";
import { Button, Checkbox, Divider } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone, QuestionCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { CommitmentOptions } from "../../talent-preferences/components/DashboardPreferences";
import { Link } from "react-router-dom";

const TalentProfileWorkPreferences = (props) => {

    const { talent } = useTalent();

    return (
        <div id="preferences" className="pt-2 pb-8">
            <ProfileContainer>
                <h4 className="textbold text-lg pb-6">Work Preferences</h4>

                <div className="flex flex-col items-start gap-2">
                    <div className="flex flex-col items-start gap-6">
                        {!talent?.supplier_client?.id && (
                            <div className="flex flex-col items-start gap-3">
                                <p className="font-semibold text-sm">
                                    Interest in Perm Positions
                                </p>

                                <div className="flex flex-row gap-2 items-center  pl-4">
                                    {talent.has_full_time_employment_interest ? (
                                        <CheckCircleTwoTone
                                            style={{ fontSize: 18 }}
                                            twoToneColor={TB.config('color.success-darker')} />
                                    ) : (
                                        <CloseCircleTwoTone
                                            style={{ fontSize: 18 }}
                                            twoToneColor={TB.config('color.danger')} />
                                    )}
                                    <p className="text-xs">
                                        Interested in Permanent, Salaried Job Opportunities
                                    </p>
                                </div>
                            </div>
                        )}
                        <div className="flex flex-col items-start gap-3">
                            <p className="font-semibold text-sm">
                                On-Site Work
                            </p>
                            <div className="flex flex-row gap-2 items-center pl-4">
                                {talent.can_travel_for_work ? (
                                    <CheckCircleTwoTone
                                        style={{ fontSize: 18 }}
                                        twoToneColor={TB.config('color.success-darker')} />
                                ) : (
                                    <CloseCircleTwoTone
                                        style={{ fontSize: 18 }}
                                        twoToneColor={TB.config('color.danger')} />
                                )}
                                <p className="text-xs">
                                    Willing to work on client site
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col items-start gap-3">
                            <p className="font-semibold text-sm">
                                Time Zones
                            </p>
                            <div className="flex flex-col items-start gap-3 pl-4">
                                <div className="flex flex-row gap-2 items-center pl4">
                                    <ClockCircleOutlined
                                        style={{ fontSize: 18 }}
                                        twoToneColor={TB.config('color.success-darker')}
                                    />

                                    <p className="text-xs">
                                        Willing to work across the following time zones
                                    </p>
                                </div>

                                <div
                                    className="pl-3 flex flex-row flex-wrap justify-start items-start max-w-[550px] gap-y-2">
                                    {TB.map(TB.TimeZonesInUS(), (zone) => {
                                        if (zone.is_in_us) {
                                            return (
                                                <div className="basis-1/3" key={zone.id}>
                                                    <Checkbox
                                                        className="pointer-events-none"
                                                        value={undefined}
                                                        readOnly={true}
                                                        checked={talent.prefers_any_timezone ? true : (talent.time_zones || []).includes(zone.id)}>
                                                        <span className="text-xs">
                                                            {zone.name}
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            )
                                        }
                                        return null
                                    })}
                                    <div className="basis-1/3">
                                        <Checkbox
                                            className="pointer-events-none"
                                            value={undefined}
                                            readOnly={true}
                                            checked={talent.prefers_any_non_us_timezone}>
                                            <span className="text-xs">
                                                Global (excluding U.S.)
                                            </span>
                                        </Checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {talent.available_hours_per_week > 0 && (
                            <div className="flex flex-row items-center gap-4 flex-wrap">
                                <div className="px-6 py-1.5 bg-gray-100">
                                    <p className="text-base font-semibold text-center">
                                        {talent.available_hours_per_week}
                                    </p>
                                </div>
                                <p className="font-semibold text-sm">
                                    Hours Per Week Typically Available for Freelance Assignments
                                </p>
                            </div>
                        )}
                    </div>


                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileWorkPreferences;